import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Image = styled.img`
  max-height: 56px;
  width: auto;
  justify-self: center;
  align-self: center;
`;

const StoreLogo = ({ logo, alt, className }) =>
  logo && <Image src={logo} alt={alt} className={className} />;

StoreLogo.defaultProps = {
  className: undefined,
};

StoreLogo.propTypes = {
  logo: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export { StoreLogo };
